







import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
export default {
  components: { CShimmer }
}
